import React from "react";

import { ANALYTICS } from "@/analytics/constants";

import { CategoryProps } from "@/interfaces/category-interface";
import { ThumbStoreProps } from "@/interfaces/stores-interface";

import Grid from "../layout/grid";
import { RetailerTile } from "./retailer-tile";

type Props = {
    stores: Array<ThumbStoreProps>;
    analytics: ANALYTICS;
    category?: CategoryProps;
    parentCategory?: CategoryProps;
    featured?: boolean;
};

export const RetailerTiles: React.FC<Props> = ({
    stores,
    analytics,
    category,
    parentCategory,
    featured,
}) => {
    const preview = stores.map((store, position) => (
        <React.Fragment key={store.id}>
            <RetailerTile
                position={position}
                key={store.id}
                store={store}
                category={category}
                parentCategory={parentCategory}
                analytics={{
                    ...analytics,
                    eventProps: {
                        ...analytics.eventProps,
                        categoryId: category?.id,
                        categoryName: category?.name,
                    },
                }}
                featured={featured}
            />
        </React.Fragment>
    ));

    return (
        <Grid fullWidth fullHeight>
            {preview}
        </Grid>
    );
};
